import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { axios } from "../../common";
import moment from "moment";

import OptionHeaders from "../options";
const { token, baseUrl, employeOid } = OptionHeaders();
const OVERTIME_REGISTRATION_SHOW = "overtime/showOvertimeRegistration";
const OVERTIME_REGISTRATION_DATA_SHOW = "overtime/showOvertimeRegistrationData";
const OVERTIME_SUMMARY_SHOW = "overtime/showOvertimeSummary";
const OVERTIME_DECLARANT_SHOW = "overtime/showOvertimeDeclarant";
const OVERTIME_APPROVAL_SHOW = "overtime/showOvertimeApproval";

export const showOvertimeRegistration = createAsyncThunk(
  OVERTIME_REGISTRATION_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get("OvertimeRegistration", {
        params: {
          $expand: "Employee",
          $filter:
            "Employee/Oid eq " +
            payload?.EmployeeOid +
            "" +
            " and OvertimeDate ge " +
            payload.FromDate +
            "" +
            " and OvertimeDate le " +
            payload.ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status}'`) +
            "]",
        },
      });
      return data.value;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getOvertimeDeclarant = createAsyncThunk(
  OVERTIME_DECLARANT_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("OvertimeRegistrationDeclar", payload, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getOvertimeApproval = createAsyncThunk(
  OVERTIME_APPROVAL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post("OvertimeForApproval", payload, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showOvertimeSummary = createAsyncThunk(
  OVERTIME_SUMMARY_SHOW,
  async (payload, thunkAPI) => {
    // const FromDate = moment(new Date(payload.FromDate)).format();
    // const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const overtime = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}OvertimeSummary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee($expand=Department,Position)"],
        filter: [
          "Employee/Oid eq " + employeOid + " and Year eq " + payload.Year,
        ],
      });
      return overtime;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showOvertimeRegistrationData = createAsyncThunk(
  OVERTIME_REGISTRATION_DATA_SHOW,
  async (payload, thunkAPI) => {
    const FromDate = moment(new Date(payload.FromDate)).format();
    const ToDate = moment(new Date(payload.ToDate)).format();
    try {
      const overtime = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}OvertimeRegistrationData`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        expand: ["Employee,Shift"],
        filter: [
          "Employee/Oid eq " +
            employeOid +
            "" +
            " and FromDate ge " +
            FromDate +
            "" +
            " and ToDate le " +
            ToDate +
            "" +
            " and RequestStatus in [" +
            payload.Status.map((status) => `'${status.toString(",")}'`) +
            "]",
        ],
      });
      return overtime;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
